import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { Button, Icon } from '@pella/sash-framework';
import { Image } from '../../../';
import { useSalesRepBio } from '../../../../hooks/use-sales-rep-bio';
import { isValidArray } from '../../../utilities/validations';

const ContactCard = ({ view, className }) => {
	const { professional } = useStaticQuery(query).contentstackConversionConfig;
	const { alternate_headings, material_icon, cta_heading, destination } = professional;
	const { salesRepBio } = useSalesRepBio();
	const salesPersonContent = alternate_headings?.find((heading) => heading.heading_type === view);

	return (
		<div
			id='15MinConnect'
			className={`fma-contactCard mx-auto my-6 grid max-w-[762px] grid-cols-1 items-center gap-x-14 gap-y-6 border border-neutral-100 bg-white px-4 py-5 md:my-8 md:grid-cols-[188px_1fr] md:px-6 xl:my-10 xl:grid-cols-[192px_1fr] ${className || ''}`}
			data-testid='fma-contact-card'
		>
			<div className='fma-contactCard-image mx-auto px-4 max-md:w-[182px]'>
				{!isValidArray(salesRepBio?.image) && (
					<div className='flex aspect-square w-[132px] items-center justify-center rounded-full bg-neutral-50 md:w-[156px]'>
						<Icon
							name='person'
							size={75}
						/>
					</div>
				)}
				{isValidArray(salesRepBio?.image) && (
					<Image
						data={salesRepBio?.image[0]}
						className='aspect-square w-[132px] rounded-full md:w-[156px]'
					/>
				)}
				{salesRepBio?.in_home_bio?.job_title && <div className='text-tiny mx-auto mt-1.5 w-fit bg-primary px-2 py-1 text-center'>{salesRepBio?.in_home_bio?.job_title}</div>}
			</div>

			<div className='fma-contactCard-content'>
				{salesPersonContent?.heading && <p className='mb-2 text-22px font-bold !leading-tight tracking-0.25px text-black md:text-28px xl:text-32px'>{salesPersonContent.heading}</p>}
				{salesPersonContent?.subheading && <p className='text-subtitle mb-4 mt-0 md:mb-5'>{salesPersonContent.subheading}</p>}

				<Button
					href={destination}
					color='tertiary-alt'
					className='!justify-start gap-x-2.5'
				>
					<Icon
						name={material_icon}
						size={14}
						className='float-left'
					/>
					{cta_heading}
				</Button>
			</div>
		</div>
	);
};

ContactCard.propTypes = {
	view: PropTypes.oneOf(['projects', 'rta']),
	className: PropTypes.string,
};

export default ContactCard;

export const query = graphql`
	query {
		contentstackConversionConfig {
			professional {
				alternate_headings {
					heading
					heading_type
					subheading
				}
				learn_about {
					heading
					group {
						icon_heading
						material_symbol
					}
				}
				material_icon
				cta_heading
				destination
			}
		}
	}
`;
